import { Component, Input, OnInit, signal } from "@angular/core";
import moment from "app/util/dayjs";

import { AuthService } from "app/services/auth/auth.service";
import { ImagesService } from "app/services/helper/images.service";
import { PersonService } from "app/services/person/person.service";
import { ProjectService } from "app/services/project/project.service";
import { UserService } from "app/services/user/user.service";
import { VacacionesService } from "app/services/vacaciones/vacaciones.service";

@Component({
    selector: "app-vacation-calendar-person",
    templateUrl: "./vacation-calendar-person.component.html",
    styleUrls: ["./vacation-calendar-person.component.scss"],
    standalone: false
})
export class VacationCalendarPersonComponent implements OnInit {
    @Input("month") month: any;
    projectId: number;
    project: any;

    person: any;
    readonly team = signal(false);

    readonly dias = signal<number[]>([]);
    readonly persons = signal<any[]>([]);
    user: number;
    date = new Date();
    dayI = new Date(this.date.getFullYear(), this.date.getMonth(), 1);
    daysL = Number(moment(new Date(this.date.getFullYear(), this.date.getMonth() + 1, 0)).format("DD"));

    mes = this.date.getMonth();
    agno = this.date.getFullYear();
    aux = " ";
    meses = {
        0: "Enero",
        1: "Febrero",
        2: "Marzo",
        3: "Abril",
        4: "Mayo",
        5: "Junio",
        6: "Julio",
        7: "Agosto",
        8: "Septiembre",
        9: "Octubre",
        10: "Noviembre",
        11: "Diciembre"
    };
    solicitudes = [];
    constructor(
        private vacationSvc: VacacionesService,
        private authSvc: AuthService,
        private personSvc: PersonService,
        private userSvc: UserService,
        private imagesSvc: ImagesService,
        private projectSvc: ProjectService
    ) {}

    ngOnInit(): void {
        if (this.month) {
            this.mes = Number(this.month) - 1;
        }
        this.projectSvc.getProjectConfig().subscribe((data) => {
            this.project = data;
            const teamMode = data.entryPoint.allow_calendar_team == 1;
            this.team.set(teamMode);
            this.userSvc.getUser().subscribe((userData) => {
                this.user = userData.id;
                this.vacationSvc
                    .getCalendarioPerson(userData.id, this.mes + 1, this.agno, teamMode ? 1 : 0)
                    .subscribe((calendarData) => {
                        this.dias.set(calendarData.dias ?? []);
                        this.persons.set(calendarData.lista ?? []);
                    });
            });
        });
    }

    changeMes(it) {
        if (it == -1) {
            if (this.mes != 0) {
                this.mes -= 1;
            } else {
                this.mes = 11;
                this.agno -= 1;
            }
        }
        if (it == 1) {
            if (this.mes != 11) {
                this.mes += 1;
            } else {
                this.mes = 0;
                this.agno += 1;
            }
        }

        //console.log(this.mes,this.agno)
        this.vacationSvc
            .getCalendarioPerson(this.user, this.mes + 1, this.agno, this.team() ? 1 : 0)
            .subscribe((data) => {
                this.dias.set(data.dias ?? []);
                this.persons.set(data.lista ?? []);
            });
    }

    getImageUser(nickname) {
        return this.imagesSvc.getImagePerson(nickname, Number(this.projectSvc.getProjectId()));
    }

    getDiaSemana(d) {
        switch (moment(this.agno + "-" + (this.mes + 1) + "-" + d).isoWeekday()) {
            case 1:
                return "L";
            case 2:
                return "M";
            case 3:
                return "X";
            case 4:
                return "J";
            case 5:
                return "V";
            case 6:
                return "S";
            case 7:
                return "D";
            default:
                return "-";
        }
    }

    getTooltip(m: number | string): string {
        switch (m) {
            case -1:
                return "No Disponible";
            case 1:
                return "Pendiente";
            case 2:
                return "Aprobada";
            case 6:
                return "Asistencia a Examen Oficial";
            case 5:
                return "Baja Médica";
            case 7:
                return "Asistencia a Médico";
            case 8:
                return "Asistencia a Juicio";
            case 9:
                return "Asistencia a Examen Oficial";
            case 10:
                return "Maternidad/Paternidad";
            case 11:
                return "Otro";
            case 12:
                return "Ausencia / Permiso retribuido";
            case 15:
                return "Solicitud Interna";
            default:
                return "Sin Seleccionar";
        }
    }
}
